import { gql } from "@apollo/client"

const GET_PREVIEW_BOOKING_CONFIRMATION_EMAIL = gql`
  query($input: PreviewBookingConfirmationEmailInput!) {
    previewBookingConfirmationEmail(input: $input) {
      html
      text
    }
  }
`

export { GET_PREVIEW_BOOKING_CONFIRMATION_EMAIL }